import React from "react";
import { Box, Button, InputAdornment, Menu, MenuItem, Stack, TextField, useMediaQuery, useTheme } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SearchIcon from "@mui/icons-material/Search";
import CheckIcon from '@mui/icons-material/Check';
import { OrderType } from "@graphql-generated";

interface SearchContainerProps {
  searchValue: string;
  selectedSort: string;
  totalSelectedFilter: number;
  onChangeSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClickFilter: () => void;
  onClickMenu: (event: OrderType, value: string) => void;
}

const SearchContainer = ({ searchValue, selectedSort, totalSelectedFilter, onClickMenu, onChangeSearch, onClickFilter }: SearchContainerProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Stack direction="row" spacing={ 2 }>
      <Button
        onClick={ onClickFilter }
        sx={{
          width: { xs: '20%', sm: '20%', md: '20%', lg: '15%' },
          height: "40px",
          border: "1px solid #000000 !important",
          textTransform: 'capitalize',
        }}
        variant="outlined"
        startIcon={<FilterListIcon />}
      >
        { isMobile ? totalSelectedFilter === 0 ? '' : totalSelectedFilter : 'Filter'}
      </Button>
      <TextField
        value={ searchValue }
        onChange={ onChangeSearch }
        InputProps={{
          style: {
            height: "40px",
            padding: "0px 12px",
            border: "1px solid #A1A5AB",
            borderRadius: "4px",
            width: "100%",
          },
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#000000", fontSize: "20px" }} />
            </InputAdornment>
          ),
        }}
        placeholder={isMobile ? "name or traits" : "Search by name or trait"}
        sx={{
          width: "100%",
          height: "40px",
          border: "none",
          whiteSpace: 'nowrap',
        }}
        variant="outlined"
      />
      {/* <Box sx={{ width: { xs: '25%', sm: '25%', md: '25%', lg: '12%' } }}>
        <Button
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          sx={{
            width: "100%",
            height: "40px",
            border: "1px solid #000000 !important",
            textTransform: 'capitalize',
          }}
          variant="outlined"
          startIcon={<SwapVertIcon />}
          endIcon={ isMobile ? undefined : <KeyboardArrowDownIcon />}
        >
          { isMobile ? '' : selectedSort }
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          sx={{ width: '100%' }}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            style: {
              transform: 'translateY(47px)',
              width: '200px',
              boxShadow: '0px 0px 20px #9E9E9E !important',
            },
          }}
        >
          <MenuItem sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => {
            onClickMenu(OrderType.Desc, 'Newest');
            handleClose();
          }}>
            Newest
            {selectedSort === 'Newest' && <CheckIcon sx={{ fontSize: '16px' }} />}
          </MenuItem>
          <MenuItem sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} onClick={ () => {
            onClickMenu(OrderType.Asc, 'Oldest');
            handleClose();
          }}>
            Oldest
            {selectedSort === 'Oldest' && <CheckIcon sx={{ fontSize: '16px' }} />}
          </MenuItem>
        </Menu>
      </Box> */}
    </Stack>
  );
};

export default SearchContainer;
